import Constants from '../common/constants';

import story1 from './stories/story1';
import story2 from './stories/story2';
import story3 from './stories/story3';
import story4 from './stories/story4';
import story5 from './stories/story5';
import story6 from './stories/story6';
import story7 from './stories/story7';
const imageFolder = Constants.IMAGE_FOLDER;

export default [
    {
        type: "story",
        time: 668,
        title: "The Teenager",
        link: {
            url: `${Constants.STORY_URL}depuber`,
            label: "Read Story",
        },
        location: {
            name: "Gush Etzion"
        },
        readingTime: "Time to read: 6 min",
        excerpt: "Emuna is fourteen years old. She had a dance performance, together with her friend Hallel but just before the performance, Hallel was stabbed to death. In her very own bedroom. ",
        body: story1,
        image: {
            mobile: `${imageFolder}depuber/omslag__mobile.jpg`,
            tablet: `${imageFolder}depuber/omslag.jpg`,
            desktop: `${imageFolder}depuber/omslag.jpg`,
            alt: ""
        }
    },
    {
        type: "story",
        time: 797,
        title: "The Discounter",
        link: {
            url: `${Constants.STORY_URL}dekiloknaller`,
            label: "Watch Video",
        },
        location: {
            name: "Gush Etzion"
        },
        readingTime: "Time to watch: 6 min ",
        excerpt: "Both settlers and Palestinians buy their chicken at Rami Levy, the cheapest supermarket in the area. But the low-priced grocery store is located in a settlement. The Jews are allowed weapons, the Palestinians are not.",
        body: story2,
        image: {
            mobile: `${imageFolder}dekiloknaller/omslag__mobile.jpg`,
            tablet: `${imageFolder}dekiloknaller/omslag.jpg`,
            desktop: `${imageFolder}dekiloknaller/omslag.jpg`,
            alt: ""
        }
    },
    {
        type: "story",
        time: 1039,
        title: "The Holy Rachel",
        link: {
            url: `${Constants.STORY_URL}deheilige`,
            label: "Read Story",
        },
        location: {
            name: "Bethlehem"
        },
        readingTime: "Time to read: 7 min",
        excerpt: "The tomb of the matriarch Rachel lies in Bethlehem, but can only be reached from Israel. Is this biblical heartland, or the essence of colonial logic?",
        body: story3,
        image: {
            mobile: `${imageFolder}deheilige/omslag__mobile.jpg`,
            tablet: `${imageFolder}deheilige/omslag.jpg`,
            desktop: `${imageFolder}deheilige/omslag.jpg`,
            alt: ""
        }
    },
    {
        type: "story",
        time: 1243,
        title: "The Perseverer",
        link: {
            url: `${Constants.STORY_URL}destandvastige`,
            label: "Watch Video",
        },
        location: {
            name: "Jerusalem"
        },
        readingTime: "Time to watch: 5 min",
        excerpt: "The Palestinian Sub Laban family lives in the Muslim quarter of the Old City of Jerusalem. In the old days, Jews used to live here. For that reason their house is now being expropriated.",
        body: story4,
        image: {
            mobile: `${imageFolder}destandvastige/omslag__mobile.jpg`,
            tablet: `${imageFolder}destandvastige/omslag.jpg`,
            desktop: `${imageFolder}destandvastige/omslag.jpg`,
            alt: ""
        }
    },
    {
        type: "story",
        time: 1511,
        title: "The Protester",
        link: {
            url: `${Constants.STORY_URL}dedemonstrant`,
            label: "Watch Video",
        },
        location: {
            name: "Ramallah"
        },
        readingTime: "Time to Watch: 8 min ",
        excerpt: "His ‘nom de guerre’ is Tito. Every week, he sets out to protest against the Israeli army. It’s David versus Goliath, he says. But he has no choice.",
        body: story5,
        image: {
            mobile: `${imageFolder}dedemonstrant/omslag__mobile.jpg`,
            tablet: `${imageFolder}dedemonstrant/omslag.jpg`,
            desktop: `${imageFolder}dedemonstrant/omslag.jpg`,
            alt: ""
        }
    },
    {
        type: "story",
        time: 1733,
        title: "The Pioneer",
        link: {
            url: `${Constants.STORY_URL}depionier`,
            label: "Watch Video",
        },
        location: {
            name: "Amona"
        },
        readingTime: "Time to watch: 10 min",
        excerpt: "The Jewish outpost Amona was built on the land of Palestinian farmers. The Palestinians initiated a lawsuit and won, thanks to a Jewish Israeli activist.",
        body: story6,
        image: {
            mobile: `${imageFolder}depionier/omslag__mobile.jpg`,
            tablet: `${imageFolder}depionier/omslag.jpg`,
            desktop: `${imageFolder}depionier/omslag.jpg`,
            alt: ""
        }
    },
    {
        type: "story",
        time: 2013,
        title: "Friends",
        link: {
            url: `${Constants.STORY_URL}devrienden`,
            label: "Read Story",
        },
        location: {
            name: "Jenin"
        },
        readingTime: "Time to read: 7 min",
        excerpt: "These boys were around ten years old when the Israeli army destroyed a part of their refugee camp in 2002. They are still friends.",
        body: story7,
        image: {
            mobile: `${imageFolder}devrienden/omslag__mobile.jpg`,
            tablet: `${imageFolder}devrienden/omslag.jpg`,
            desktop: `${imageFolder}devrienden/omslag.jpg`,
            alt: ""
        }
    }
]



// WEBPACK FOOTER //
// ./src/data/timeline-stories.js